




import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class fileUploadItem extends Vue {
  @Prop() item!: any;
}
